// import * as React from 'react'
import React, { useEffect, useState } from 'react'
import { Col, Menu, Row, Button, Avatar, Spin } from 'antd'
import Logo from 'images/logo.png'
import { Header } from 'antd/es/layout/layout'
import { useAuth0 } from '@auth0/auth0-react'
import { HamburgerMenu } from 'components/common'
import { LoginOutlined, LogoutOutlined } from '@ant-design/icons'
import { useWindowSize } from 'lib/logic/common'
import config from 'config'
import useAuth0PermissionLevel from 'hooks/useUserPermissionLevel'

export interface HeaderProps {
  title: string
}

const HeaderMenu = ({ title }: HeaderProps): JSX.Element => {
  const { isAuthenticated, loginWithRedirect, logout, user, isLoading } = useAuth0()
  const [width] = useWindowSize()
  const [isMobile, setIsMobile] = useState<boolean>()
  const { userPermission, permissionLoading } = useAuth0PermissionLevel()

  const handleLogout = () => {
    if (typeof window !== 'undefined') {
      // localStorageに保存したデータをクリアする
      localStorage.removeItem('estimateObject')
      localStorage.removeItem('auth0Token')
      localStorage.removeItem('currentRateCategoryTab')
    }
    logout({
      returnTo: window.location.origin,
    })
  }

  useEffect(() => {
    if (width === 0) {
      return setIsMobile(true)
    }
    if (width < 821) {
      return setIsMobile(true)
    }
    return setIsMobile(false)
  }, [width])

  return (
    <>
      <Header
        className="header"
        style={{
          paddingInline: '0px',
        }}
      >
        <Menu>
          {/* <PageTitle title={title} /> */}
          <Row>
            <Col span={24}>
              <div className="logo">
                <img alt="Logo" src={Logo} />
              </div>
              {/* ログインボタンPC */}
              {!isMobile ? (
                <>
                  {isAuthenticated ? (
                    <Spin
                      spinning={isLoading || permissionLoading}
                      tip="Loading..."
                    >
                      <div className="login">
                        <div>{user.email}</div>
                        {(userPermission === 'master' || userPermission === 'admin') && (
                          <Avatar className="ml-2">{userPermission.toUpperCase()}</Avatar>
                        )}
                        <Button danger className="mx-2" type="primary" onClick={() => handleLogout()}>
                          <LogoutOutlined />
                          Log out
                        </Button>
                      </div>
                    </Spin>
                  ) : (
                    <div className="login">
                      <Button
                        className="mx-2"
                        type="primary"
                        onClick={() => loginWithRedirect({ connection: config.auth0.conCustomer })}
                      >
                        <LoginOutlined />
                        Log in
                      </Button>
                    </div>
                  )}
                </>
              ) : (
                <HamburgerMenu></HamburgerMenu>
              )}
            </Col>

            {/* ログインボタンmobile */}
            {isMobile && (
              <>
                {isAuthenticated ? (
                  <Col span={24}>
                    <Spin
                      spinning={isLoading || permissionLoading}
                      tip="Loading..."
                    >
                      <div className="login">
                        <div>{user.email}</div>
                        {(userPermission === 'master' || userPermission === 'admin') && (
                          <Avatar className="batch">{userPermission.toUpperCase()}</Avatar>
                        )}
                        <Button
                          className="ml-2"
                          danger
                          size="small"
                          type="primary"
                          onClick={() => handleLogout()}
                        >
                          <LogoutOutlined />
                          Log out
                        </Button>
                      </div>
                    </Spin>
                  </Col>
                ) : (
                  <Col span={24}>
                    <div className="login">
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => loginWithRedirect({ connection: config.auth0.conCustomer })}
                      >
                        <LoginOutlined />
                        Log in
                      </Button>
                    </div>
                  </Col>
                )}
              </>
            )}
            {/* </Col> */}
          </Row>
        </Menu>
      </Header >
    </>
  )

}

export default HeaderMenu
